const MAX_PHOTO_BYTES = 5 * 1024 * 1024;

const ALLOWED_PHOTO_MIME_TYPES = ["image/jpeg", "image/png", "image/webp", "image/heic"];

export { MAX_PHOTO_BYTES, ALLOWED_PHOTO_MIME_TYPES };
